import {MyCourseListModel} from "~~/package/mapper/course/model/MyCourseListModel";
import {CourseDetailModel} from "~~/package/mapper/course/model/CourseDetailModel";
import {CourseRecentlyModel} from "~~/package/mapper/course/model/CourseRecentlyModel";
import type CourseRecentlyResponse from "~~/package/apis/course/response/CourseRecentlyResponse";

export class CourseHelper {
    public static mappingCourseList(courseList: MyCourseListModel): MyCourseListModel {
        return MyCourseListModel.create(courseList);
    }

    public static mappingCourseDetail(courseDetail: CourseDetailModel): CourseDetailModel {
        return CourseDetailModel.create(courseDetail);
    }

    public static mappingCourseRecently(course: Partial<CourseRecentlyResponse>): CourseRecentlyModel {
        return CourseRecentlyModel.create(course);
    }
}
